import { Component, EventEmitter, Input, OnInit, Output, signal, computed, SimpleChanges } from '@angular/core';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { Client, _ } from '@mira-avant/mtlibs';
import { ClientService } from '../../../../services/client.service';

@Component({
	selector: 'app-clients-selector',
	imports: [AngularModule, ZorroModule],
	standalone: true,
	templateUrl: './clients-selector.html',
	styleUrl: './clients-selector.scss',
})
export class ClientsSelector implements OnInit {
	@Input() public selectedClientUuids: string[] = [];
	@Output() public onChange = new EventEmitter<Client[]>();

	public allClients = signal<Client[]>([]);
	public selectedUuids = signal<string[]>([]);

	public selectedClients = computed(() => this.allClients().filter(c => this.selectedUuids().includes(c.uuid)));

	constructor(public clientService: ClientService) {}

	ngOnInit(): void {
		this.clientService.getAll$().then(clients => {
			this.allClients.set(clients);
			this.selectedUuids.set([...this.selectedClientUuids]);
			this.onChange.emit(this.selectedClients());
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedClientUuids']) {
			this.selectedUuids.set([...this.selectedClientUuids]);
		}
	}

	public onSelectionChange(newUuids: string[]): void {
		this.selectedUuids.set(newUuids);
		this.onChange.emit(this.selectedClients());
	}
}
